var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconArrowBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-171 -142) translate(165 136) translate(6 6)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4d7cfe",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.328.814C8.61.521 9.064.491 9.382.73l.077.065 4.697 4.537c.307.297.324.777.054 1.093l-.067.07-4.697 4.337c-.325.3-.831.279-1.13-.046-.277-.3-.282-.754-.025-1.058l.07-.072 4.073-3.762-4.087-3.948c-.293-.284-.323-.737-.085-1.055l.066-.077z",
    transform: "matrix(-1 0 0 1 19.2 6.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.78 5.127c.441 0 .8.358.8.8 0 .41-.31.749-.707.795l-.094.005H.8c-.442 0-.8-.358-.8-.8 0-.41.309-.748.707-.794L.8 5.127h11.98z",
    transform: "matrix(-1 0 0 1 19.2 6.4)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowBack);
export default __webpack_public_path__ + "static/media/icon-arrow-back.97afdf02a84e52517524c33e1d2e09f2.svg";
export { ForwardRef as ReactComponent };